import { useEffect } from 'react'
import { useRouteError } from 'react-router-dom'

import LoadingAnimation from '../../components/LoadingAnimation'

import { fetchAppConfig } from '../../state/actions/appConfigActions'

import { appConfigSignal, appConfigLoadedSignal, appConfigErrorSignal } from '../../state/signals/appConfigSignals.js'

export default function ErrorPage() {

    const error = useRouteError()

    let print = true

    useEffect(
        () => {
            if (!appConfigLoadedSignal.value && !appConfigErrorSignal.value) {
                fetchAppConfig()
            }
        }
    )

    if (!appConfigLoadedSignal.value) {
        return (<LoadingAnimation />)
    }

    if (print) {
        console.error("Rendering an error page, here's how you got here")
        console.log(error)
        console.log("Config:")
        console.log(appConfigSignal.value)
    }

    let body = null
    const ssoUrl = appConfigSignal.value && appConfigSignal.value.ssoBaseUrl ? appConfigSignal.value.ssoBaseUrl : ""
    const localDebug = window.location.hostname === "localhost"
    if (Object.prototype.hasOwnProperty.call(error, 'code')) {
        if (print) {
            console.log("Error has a code")
        }
        switch (error.code.toString()) {
            case '401':
                if (!localDebug) {
                    // redirect to sso to sign on unless we are doing local development.
                    // for local development we will load a page with link to give opportunity to set the accessToken manually
                    window.location.href=`${ssoUrl}?clientid=4`
                }
                body = (
                    <>
                        <h1>Unauthorized</h1>
                        <p>
                            You are not logged in, or your session has expired.&nbsp;
                            <a href={ssoUrl.concat("/?clientid=4")}>Please click here to login.</a>
                        </p>
                    </>
                )
                break
            default:
                if (print) {
                    console.log("No special handling for error code ".concat(error.code).concat(" of type ").concat(typeof error.code))
                }
                break
        }
    }
    else if(print){
        console.log("Error does not have a code")
    }
    if(body == null){
        body = (
            <>
                <h1>Oops!</h1>
                <p>Sorry, an unexpected error has occurred.</p>
                <p>
                    <i>{error.statusText || error.message}{ error.cause ? error.cause : undefined }</i>
                </p>
            </>
        )
    }

    return (
        <div id="error-page">{body}</div>
    );
}